import React from "react";
import styled from "styled-components";
import webdevelopment from '../Assets/Azharpic1.jpg'
const PageWrapper = styled.div`
  max-width: 1000px;
  margin: 40px auto;
  padding: 20px;
  line-height: 1.8;
  color: #333;
  font-size: 16px;

  @media (max-width: 1024px) {
    max-width: 90%;
    font-size: 15px;
  }

  @media (max-width: 768px) {
    max-width: 95%;
    font-size: 14px;
    padding: 15px;
    line-height: 1.7;
  }

  @media (max-width: 480px) {
    font-size: 13px;
    padding: 12px;
    text-align: center;
    line-height: 1.6;
  }
`;
const MobileAppImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  // z-index: -1;
  margin-bottom: 20px;
  @media (max-width:600px){
  width:100%;
  height:220px;
}
@media (min-width:601px) and (max-width:1024px){
  width:100%;
  height:320px;
}
`
const Title = styled.h1`
  text-align: center;
  margin-bottom: 20px;
  background: linear-gradient(90deg, #6a11cb, #2575fc);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 2rem;

  @media (max-width: 768px) {
    font-size: 1.6rem;
  }

  @media (max-width: 480px) {
    font-size: 1.4rem;
  }
`;
const Wrap = styled.div`
  padding: 0;
  margin: 0;
  background-color: #f9f9f9;
  width: 100%;
  height: 100%;
  // padding: 20px 0;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
`;
export default function TermsAndConditions() {
  return (
    <Wrap>
      <MobileAppImage src={webdevelopment} alt='Background' />   
    <PageWrapper>
      <Title>Terms & Conditions</Title>
      <p>
        Welcome to <b>AttractDeals</b>. By accessing our website, you agree to
        the following terms and conditions.
      </p>
      <p>
        <b>Use of Content:</b> All content is for informational purposes only
        and should not be considered professional advice.
      </p>
      <p>
        <b>Affiliate Links:</b> We participate in the Amazon Associates Program.
        When you click links and purchase, we may earn a small commission at no
        extra cost to you.
      </p>
      <p>
        <b>Liability:</b> We are not responsible for product quality,
        availability, or shipping delays. These are handled by Amazon.
      </p>
      <p>
        <b>Changes:</b> We may update these terms anytime without prior notice.
      </p>
    </PageWrapper>
    </Wrap>
  );
}
